import React, { useEffect, useState } from "react";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Box, Button, styled, Typography } from "@mui/material";
import { Link, useLocation } from "react-router-dom";

import { colors } from "@/theme/overrides/colors";

import Tabs from "./Tabs";

interface Props {
  backTo: string;
  hasDetails: boolean;
  renderProgramDetails: () => React.ReactNode;
  renderMealPlan: () => React.ReactNode;
}

const Root = styled("div")({
  flexGrow: 1,
});

const ProgramForm: React.FC<Props> = ({
  backTo,
  hasDetails,
  renderProgramDetails,
  renderMealPlan,
}) => {
  const [activeTab, setActiveTab] = useState(0);
  const { state } = useLocation();
  useEffect(() => {
    if (state?.fromDuplicateRecipe) {
      setActiveTab(1);
    }
  }, [state?.fromDuplicateRecipe]);

  return (
    <Root>
      <Button
        component={Link}
        to={backTo}
        startIcon={<ArrowBackIcon fontSize="small" color="primary" />}
        variant="text"
      >
        <Typography variant="body2" color={colors.black}>
          Back to plans
        </Typography>
      </Button>
      <Box display="flex" marginBottom={4}>
        <Box position="relative" width="100%" marginTop={2}>
          <Tabs
            hasDetails={hasDetails}
            activeTab={activeTab}
            onChangeTab={setActiveTab}
          />
          {activeTab === 0 && renderProgramDetails()}
          {activeTab === 1 && renderMealPlan()}
        </Box>
      </Box>
    </Root>
  );
};

export default ProgramForm;
